<template>
  <SortSearch
    default-sort="latest"
    dimension="LatestDesigns"
    :force-experience="getMerch"
    query="dog"
  />
</template>

<script>
import SortSearch from '@/components/SortSearch';
import { mapGetters } from 'vuex';

export default {
  components: {
    SortSearch
  },
  computed: {
    ...mapGetters('experience', ['getMerch'])
  },
  nuxtI18n: {
    paths: {
      en: '/merch/latest-designs/p/:page',
      es: '/merch/ultimos-disenos/p/:page',
      pt: '/merch/novos-designs/p/:page',
      de: '/merch/neue-designs/p/:page'
    }
  },
  head() {
    return {
      meta: [{ hid: 'robots', name: 'robots', content: 'noindex, follow' }]
    };
  }
};
</script>
